/* MAYIILANG — Garde-fou des formulaires publics (contact + newsletter) :
   1) Validation côté client : messages clairs en français avant même l'envoi
      au serveur, en plus des erreurs Shopify déjà gérées en Liquid.
   2) Anti-spam : champ piège (honeypot) invisible + délai minimal entre le
      chargement de la page et l'envoi. Bloque la grande majorité des robots
      de spam qui remplissent tous les champs du formulaire ou l'envoient de
      manière instantanée. Côté serveur, Shopify continue de son côté à
      valider les champs réels (email, etc.) : ceci est une première ligne
      de défense, pas un remplacement. */
(function () {
  var MIN_SUBMIT_MS = 1200;
  var pageLoadedAt = Date.now();

  function setFieldError(field, message) {
    field.setAttribute('aria-invalid', 'true');
    var errorId = (field.id || 'mayi-field') + '-mayi-error';
    var existing = document.getElementById(errorId);
    if (!existing) {
      existing = document.createElement('small');
      existing.id = errorId;
      existing.className = 'form__message mayi-form-error';
      field.insertAdjacentElement('afterend', existing);
    }
    existing.textContent = message;
    var describedBy = field.getAttribute('aria-describedby') || '';
    if (describedBy.indexOf(errorId) === -1) {
      field.setAttribute('aria-describedby', (describedBy ? describedBy + ' ' : '') + errorId);
    }
  }

  function clearFieldError(field) {
    field.removeAttribute('aria-invalid');
    var errorId = (field.id || 'mayi-field') + '-mayi-error';
    var existing = document.getElementById(errorId);
    if (existing) existing.remove();
  }

  function messageFor(field) {
    if (field.validity.valueMissing) {
      return 'Ce champ est obligatoire.';
    }
    if (field.validity.typeMismatch && field.type === 'email') {
      return 'Merci de saisir une adresse e-mail valide.';
    }
    if (field.validity.patternMismatch) {
      return 'Merci de vérifier le format de ce champ.';
    }
    return 'Merci de vérifier ce champ.';
  }

  function validateForm(form) {
    var valid = true;
    var firstInvalid = null;
    var fields = form.querySelectorAll('input[required], input[type="email"], textarea[required]');
    fields.forEach(function (field) {
      if (field.hasAttribute('data-mayi-hp')) return;
      clearFieldError(field);
      if (!field.checkValidity()) {
        valid = false;
        if (!firstInvalid) firstInvalid = field;
        setFieldError(field, messageFor(field));
      }
    });
    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  function initGuard(form) {
    form.addEventListener('submit', function (event) {
      var honeypot = form.querySelector('[data-mayi-hp]');
      if (honeypot && honeypot.value.trim() !== '') {
        // Very likely a bot: block silently, no error shown (do not help it retry).
        event.preventDefault();
        return;
      }
      if (Date.now() - pageLoadedAt < MIN_SUBMIT_MS) {
        event.preventDefault();
        return;
      }
      if (!validateForm(form)) {
        event.preventDefault();
      }
    });

    form.querySelectorAll('input[required], input[type="email"], textarea[required]').forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.checkValidity()) clearFieldError(field);
      });
    });
  }

  document.querySelectorAll('#ContactForm, .newsletter-form').forEach(initGuard);
})();
